import { render, staticRenderFns } from "./RcvD_Purchase.vue?vue&type=template&id=022b97b4"
import script from "./RcvD_Purchase.vue?vue&type=script&lang=js"
export * from "./RcvD_Purchase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports